import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Card, Col, Row, TextComponent } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import DashboardTooltip from '../../dashboard-common/dashboard-tooltip/dashboard-tooltip';

import './progress-cards.scss';

interface Props {
  currentViolations: number;
  maxViolations: number;
}

const Violations: FunctionComponent<Props> = ({
  currentViolations,
  maxViolations,
}) => {
  const { isMobile } = useResponsiveness();
  const { t } = useTranslation(['dashboardTemplates']);

  const tooltipText = t(
    'dashboardTemplates:opening_position_risk_violation_tooltip',
  );

  return (
    <Card
      hoverable={false}
      className={classNames(
        'progress-cards',
        'progress-cards__card',
        'progress-cards__card--daily-violations',
      )}
    >
      <Row justify={'space-between'}>
        <Col xs={16} sm={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col xs={14} sm={20}>
              <TextComponent weight={400} level={isMobile ? 5 : 3}>
                {t('dashboardTemplates:violations')}
              </TextComponent>
            </Col>

            {!isMobile && <DashboardTooltip tooltipText={tooltipText} />}

            <Col xs={8} span={24}>
              <TextComponent level={isMobile ? 3 : 2} weight={600}>
                {currentViolations}/
              </TextComponent>
              <TextComponent level={isMobile ? 3 : 2} weight={400}>
                {maxViolations}
              </TextComponent>
            </Col>
          </Row>
        </Col>

        {isMobile && (
          <Row align={'middle'}>
            <DashboardTooltip tooltipText={tooltipText} />
          </Row>
        )}
      </Row>
    </Card>
  );
};
export default Violations;
